import DataObjectField from "@/utilities/classes/data-object-field";

const buildCreateAccountDataObject = vData => {
  const fields = [
    new DataObjectField(vData.sub, 6),
    new DataObjectField(vData.email, 9),
  ];

  const dataObject = {
    qdbapi: {
      udata: "SHARC_CREATE_ACCOUNT",
      apptoken: "dsgdzckckic6iabhuap3kdyiwdgc",
      field: fields
    }
  };
  return dataObject;
};

export default buildCreateAccountDataObject;